export const DEFAULT_COLOR = 'light';
